import recombee from "recombee-js-api-client";
import { recombeeConfig } from "../config";

// Initialising Recombee
let recombeeClient = null;

export const getRecombeeClient = ({ databaseId: databaseIdFromParam, region: regionFromParam } = {}) => {
  if (recombeeClient) return recombeeClient;
  const { databaseId: defaultDatabseId, region: defaultRegion, publicKey } = recombeeConfig || {};
  const databaseId = databaseIdFromParam || defaultDatabseId;
  const region = regionFromParam || defaultRegion;
  if (databaseId && region) {
    recombeeClient = new recombee.ApiClient(databaseId, publicKey, { region });
  }
  return recombeeClient;
};
const useRecombee = ({ databaseId: databaseIdFromParam, region: regionFromParam } = {}) => {
  return getRecombeeClient({ databaseId: databaseIdFromParam, region: regionFromParam });
};

export default useRecombee;
